import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { PageViewTracker } from "./components/PageViewTracker";

// Pages
import Landing from "./pages/Landing";
import Templates from "./pages/Templates";
import TemplateDetail from "./pages/TemplateDetail";
import TemplateEditor from "./pages/TemplateEditor";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Pricing from "./pages/Pricing";
import Prospects from "./pages/Prospects";
import AIGenerator from "./pages/AIGenerator";
import MyOrganization from "./pages/MyOrganization";
import Partners from "./pages/Partners";
import Programs from "./pages/Programs";
import Grants from "./pages/Grants";
import GrantsHub from "./pages/GrantsHub";
import SavedTemplates from "./pages/SavedTemplates";
import AdminDashboard from "./pages/AdminDashboard";
import DesignStudio from "./pages/DesignStudio";
import SharedDesignView from "./pages/SharedDesignView";
import Consulting from "./pages/Consulting";
import HelpPage from "./pages/HelpPage";
import CommunityHub from "./pages/CommunityHub";
import { AffordableGrantSearchTool, InstrumentlAlternative, GrantstationAlternative, HowToFindCorporateSponsors } from "./pages/SeoLandingPages";
import BlogList from "./pages/blog/BlogList";
import BlogPost from "./pages/blog/BlogPost";

function AppLayout() {
  const location = useLocation();
  const isSharedPage = location.pathname.startsWith('/shared/');

  if (isSharedPage) {
    return (
      <main>
        <Routes>
          <Route path="/shared/:shareId" element={<SharedDesignView />} />
        </Routes>
      </main>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <PageViewTracker />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/templates/:id" element={<TemplateDetail />} />
          <Route path="/templates/:id/edit" element={<TemplateEditor />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/shared/:shareId" element={<SharedDesignView />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/prospects" element={<Prospects />} />
          <Route path="/ai-generator" element={<AIGenerator />} />
          <Route path="/organization" element={<MyOrganization />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/grants" element={<GrantsHub />} />
          <Route path="/grants/tracker" element={<Grants />} />
          <Route path="/my-templates" element={<SavedTemplates />} />
          <Route path="/design-studio" element={<DesignStudio />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/community" element={<CommunityHub />} />
          {/* SEO landing pages */}
          <Route path="/affordable-grant-search-tool" element={<AffordableGrantSearchTool />} />
          <Route path="/instrumentl-alternative" element={<InstrumentlAlternative />} />
          <Route path="/grantstation-alternative" element={<GrantstationAlternative />} />
          <Route path="/how-to-find-corporate-sponsors-for-nonprofits" element={<HowToFindCorporateSponsors />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppLayout />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
